var generateRandId = function () { return Math.floor(Math.random() * 10000000) + Date.now(); };
// remove all non-digit characters from a string, and remove any leading zeroes
var removeAllNonDigitCharsAndLeadingZeroes = function (str) {
    return str.replace(/\D/g, '').replace(/^0+/, '');
};

export { generateRandId, removeAllNonDigitCharsAndLeadingZeroes };
//# sourceMappingURL=utils.esm.js.map
